import { fetchApi } from '@/config/axiosSetting.ts';
import {
  ValidateRequestDataType,
  ValidateRequestResponseType,
} from '@/modules/Auth/queries/validateOtp/validateOtpMutation.type.ts';

export const validateOtpMutationFunction = (
  formData: ValidateRequestDataType,
): Promise<ValidateRequestResponseType> => {
  return fetchApi({
    method: 'post',
    url: 'verification/login/validate_otp/',
    data: formData,
  });
};
